import { createFileRoute } from "@tanstack/react-router";
import { CityLandingPage, buildCityLandingHead, type CityLandingConfig } from "@/components/CityLandingPage";

const CONFIG: CityLandingConfig = {
  slug: "woodland-park",
  name: "Woodland Park",
  region: "Teller County / Ute Pass",
  heroEyebrow: "Woodland Park Marketing Hub",
  heroTitle: { lead: "Woodland Park marketing for ", gold: "Ute Pass", trail: " businesses" },
  heroDescription:
    "Woodland Park sits 30 minutes west of Colorado Springs at 8,400 ft — a mix of full-time mountain residents, second-home owners, and summer tourist traffic from Pikes Peak and Cripple Creek. We build websites and SEO programs that catch both local-search demand and seasonal tourist intent.",
  intro:
    "Woodland Park has two buyer cycles: year-round Teller County locals who Google for trades and services, and a heavy June–September tourist wave that searches for restaurants, lodging, outfitters, and activities. We build sites and SEO that win both — without making locals feel like an afterthought.",
  neighborhoods: [
    "Downtown Woodland Park",
    "Tamarac",
    "Paradise Estates",
    "Sunnywood",
    "Highland Lakes",
    "Divide-adjacent",
    "Green Mountain Falls",
    "Cascade",
  ],
  marketSnapshot:
    "Teller County's Map Pack is light on local competition but heavy on out-of-area franchises bidding on tourist-intent keywords. Wins come from local proof, year-round content, and a website that loads fast on weak mountain LTE.",
  highlights: [
    {
      title: "Two-cycle content built in",
      body: "Locals search for furnace repair in October and snow removal in January. Tourists search for things to do in July. We build content for both audiences so your site earns leads year-round, not just in summer.",
    },
    {
      title: "Mountain-fast site builds",
      body: "Spotty LTE between Woodland Park and Divide kills slow sites. We build under 1MB to make sure your page loads before the user gives up and calls a competitor.",
    },
    {
      title: "Pikes Peak corridor reach",
      body: "Most Woodland Park trades also serve Divide, Florissant, Green Mountain Falls, and Cascade. We rank you across the full Ute Pass / Pikes Peak corridor footprint.",
    },
  ],
  services: [
    { to: "/colorado-springs-seo", title: "SEO", body: "Map Pack rankings, local content, and review velocity tuned to Teller County and Ute Pass search behavior." },
    { to: "/colorado-springs-web-design", title: "Web design", body: "Fast, mobile-first sites engineered for mountain LTE and built to convert tourist + local traffic." },
    { to: "/colorado-springs-google-maps", title: "Google Maps", body: "GBP optimization, citations, and review programs to win the Woodland Park 3-pack." },
    { to: "/geo-ai", title: "GEO / AI search", body: "Get cited in ChatGPT, Perplexity, and Google AI Overviews when buyers ask AI about Woodland Park services." },
  ],
  learnArticleSlugs: [
    "/learn/local-seo-guide",
    "/learn/google-business-profile",
    "/learn/website-conversion",
    "/learn/get-more-reviews",
    "/learn/marketing-budget",
    "/learn/seo-vs-ppc",
  ],
  learnIntro:
    "Woodland Park businesses win by ranking for both local-trade and tourist-intent searches. These six pieces explain how to compound both.",
  closingCta:
    "30-minute call. We'll audit your Woodland Park Map Pack position, look at the Springs franchises bidding on your tourist traffic, and tell you what to fix first.",
};

export const Route = createFileRoute("/woodland-park")({
  head: () =>
    buildCityLandingHead(CONFIG, {
      metaTitle: "Woodland Park Marketing Agency | SEO, Web Design & Maps | CWI",
      metaDescription:
        "Woodland Park, Divide, and Ute Pass SEO, web design, and Google Maps optimization. Local Colorado team, transparent reporting, no long-term contracts.",
    }),
  component: () => <CityLandingPage config={CONFIG} />,
});
